import React, { useCallback, useState } from "react";
import classNames from "classnames";
import Spinner from "./Spinner";

interface ButtonProps {
  onClick: () => Promise<void>;
  children: React.ReactNode;
  color?: string;
  disabled?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  onClick,
  children,
  color,
  disabled,
}) => {
  const [loading, setLoading] = useState(false);

  const buttonDisabled = disabled || loading;

  const handleClick = useCallback(async () => {
    if (buttonDisabled) {
      return;
    }

    setLoading(true);
    await onClick();
    setLoading(false);
  }, [buttonDisabled, onClick]);

  return (
    <button
      onClick={handleClick}
      disabled={disabled}
      className={classNames(
        "px-6 py-1 rounded text-md font-medium transition duration-200",
        {
          "text-neutral-100": true,
          "bg-blue-500  hover:bg-blue-700": !color && !buttonDisabled,
          "bg-red-500 hover:bg-red-700": color === "danger" && !buttonDisabled,
          "cursor-not-allowed bg-blue-300 border-gray-300":
            !color && buttonDisabled,
          "cursor-not-allowed bg-red-300  border-gray-300":
            color === "danger" && buttonDisabled,
        }
      )}
    >
      <div className="flex flex-col items-center">
        {loading ? <Spinner size="xs" /> : children}
      </div>
    </button>
  );
};

export default Button;
